import React from 'react';
import styled from 'styled-components';

const StyledHeader = styled.header`
  padding: .5rem;
  border-bottom: 1px solid #999;
`;

const StyledLogoImage = styled.img.attrs({
  src: 'https://laputan.com.au/wp-content/uploads/2020/05/cropped-logo-long.png',
})`
  height: 1.6rem;
  margin: 0;
`;

const StyledLink = styled.a`
`;

const Header = () => (
  <StyledHeader>
    <StyledLink href="https://laputan.com.au">
      <StyledLogoImage />
    </StyledLink>
  </StyledHeader>
);

export default Header;
